import React from 'react'
import { Button } from 'components'
import styles from './CheckBox.module.scss'
import { CheckBoxProps, CheckBoxStatus } from './CheckBox.types'
import cl from 'classnames'
import { IconCheckboxON, IconCheckboxOFF, IconCheckboxMinusReverse } from 'assets'

const CheckBoxComponent = (props: CheckBoxProps) => {
  const { label, checked, onClick, className, status } = props

  const getStatusSymbol = () => {
    switch (status) {
      case CheckBoxStatus.UNCHECKED: return ''
      case CheckBoxStatus.CHECKED: return <IconCheckboxON />
      case CheckBoxStatus.ALL_CHILDREN_ARE_CHECKED: {
        return <span className={styles.partiallyChecked}>■</span>
      }
      case CheckBoxStatus.PARTIALLY_CHECKED: return <IconCheckboxMinusReverse />
      default: return ''
    }
  }

  return (
    <Button
      className={cl(styles.container, className)}
      onClick={onClick}
    >
      {
        status
          ? getStatusSymbol()
          : checked
            ? <IconCheckboxON />
            : <IconCheckboxOFF />
      }
      {/* <span className={styles.checkBox}>{
        status
          ? getStatusSymbol()
          : checked ? '✓' : ''
        // checked ? '✓' : '–'
      }</span> */}
      {label}
    </Button>
  )
}

const CheckBox = CheckBoxComponent
export { CheckBox }
